import { type DigitalSettingsProps, digitalSettingsProfileMenu } from 'digital-settings/shared/menu-config'
import { type MenuItem, ProfileMenuGroup } from 'shared/types'
import { type WebhookSettingsProps, webhooksProfileMenu } from 'webhooks/shared/menu-config'

import { acquirerProfileMenu } from '~/domains/acquirer/ports/acquirer.menu'
import { miscellaneousProfileMenu } from '~/domains/miscellaneous/ports/miscellaneous.menu'
import { stoneAccountProfileMenu } from '~/domains/stone-account/ports/stone-account.menu'

import { type Entity } from '../../infra/deus-ex-machina/ports'
import { sortMenuByPriority } from '../shared/helpers'

interface ProfileMenuPoiGates {
  hasLinkPoi?: boolean
  hasEcommercePoi?: boolean
}

export function profileMenuConfig(
  entity: Entity,
  digitalSettingsConfig?: DigitalSettingsProps,
  webhookSettingsConfig?: WebhookSettingsProps,
  isOneStone?: boolean,
  poiGates: ProfileMenuPoiGates = {}
): Record<string, MenuItem[]> {
  const { hasLinkPoi = false, hasEcommercePoi = false } = poiGates
  const profileMenuItems = sortMenuByPriority([
    ...stoneAccountProfileMenu(),
    ...miscellaneousProfileMenu(),
    ...acquirerProfileMenu(entity),
    ...digitalSettingsProfileMenu({ ...digitalSettingsConfig, isOneStone, hasLinkPoi, hasEcommercePoi }),
    ...webhooksProfileMenu({ ...webhookSettingsConfig, hasEcommercePoi })
  ])

  const groupedItems = profileMenuItems.reduce<Record<string, typeof profileMenuItems>>((groups, item) => {
    const group = item.group || ProfileMenuGroup.ACCOUNT_SETTINGS
    if (!groups[group]) {
      groups[group] = []
    }
    groups[group].push(item)
    return groups
  }, {})

  const finalItems = Object.keys(ProfileMenuGroup).reduce<Record<string, MenuItem[]>>((acc, groupKey) => {
    const items = groupedItems[ProfileMenuGroup[groupKey as keyof typeof ProfileMenuGroup]] ?? []
    const filteredItems = items.filter(item => item.show)

    if (filteredItems?.length) {
      acc[ProfileMenuGroup[groupKey as keyof typeof ProfileMenuGroup]] = filteredItems
    }

    return acc
  }, {})

  return finalItems
}
